/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import { shareLinkStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsShareLink";
import getProp from "@insite/mobius/utilities/getProp";
import Envelope from "@monsma/XDL/Icons/Envelope";
import Link from "@monsma/XDL/Icons/Link";
import Print from "@monsma/XDL/Icons/Print";
import { css } from "styled-components";

shareLinkStyles.wrapper = {
    css: css`
        display: flex;
        align-items: center;
        margin-top: 30px;

        > * {
            margin-right: 30px;

            &:last-child {
                margin-right: 0;
            }
        }
    `,
};

shareLinkStyles.link = {
    link: {
        icon: {
            iconProps: {
                src: Envelope,
                size: 12,
                color: "common.ui5",
            },
            position: "left",
        },
    },
    modal: {
        size: 600,
        cssOverrides: {
            modalTitle: css`
                ${getProp("theme.modal.defaultProps.cssOverrides.modalTitle")}
            `,
            modalContent: css`
                ${getProp("theme.modal.defaultProps.cssOverrides.modalContent")}
            `,
        },
    },
};

(shareLinkStyles as any).printClickable = {
    icon: {
        iconProps: {
            src: Print,
            size: 12,
            color: "common.ui5",
        },
        position: "left",
    },
};

(shareLinkStyles as any).copyLinkClickable = {
    icon: {
        iconProps: {
            src: Link,
            size: 12,
            color: "common.ui5",
        },
        position: "left",
    },
};
